"use client";

import { FIELD_CLASSNAME } from "@/src/components/online-scheduling/types";
import { Label } from "@/src/components/shadcn/ui/label";
import { Textarea } from "@/src/components/shadcn/ui/textarea";
import { Muted } from "@/src/components/typography";

export function VisitStep({
  reasonForVisit,
  onChangeReason,
  required = false,
}: {
  reasonForVisit: string;
  onChangeReason: (reason: string) => void;
  /** Per-tenant policy: when set, the reason is mandatory and the step's Continue stays disabled until filled. */
  required?: boolean;
}) {
  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="reason-for-visit">
          What brings you in? {required ? null : <span className="font-normal text-muted-foreground">(optional)</span>}
        </Label>
        <Textarea
          id="reason-for-visit"
          value={reasonForVisit}
          onChange={(event) => onChangeReason(event.target.value)}
          placeholder="Briefly describe the reason for your visit…"
          rows={3}
          maxLength={200}
          aria-required={required}
          className={FIELD_CLASSNAME}
        />
      </div>

      <Muted className="block">For a medical emergency, call 911.</Muted>
    </div>
  );
}
